import PchInvoiceMdl from '@/models/Purchase/PchPurchaseInvoice'
import Includes from './PurchaseInvoiceIncludes'

export default async idInvoice => {
    try {
        //
        let invoice = await PchInvoiceMdl.include(Includes).find(idInvoice)
        //
        return invoice
    } catch (error) {
        return error.data.response
    }
}
